import { useDispatch } from 'react-redux';
import { createWishlist } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useCreateWishlistAction = (): typeof createWishlist => {
  const dispatch = useDispatch();

  return bindActionCreators(createWishlist, dispatch);
};
